// react core
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// components
import FilterMenu from 'components/sub_header/filter_menu';
import AskButton from 'components/sub_header/ask_btn';
import SubTitle from 'components/sub_header/sub_title';

import conf from 'conf/ajax';
// api
import { get_tags_from_server } from 'commons/api';
import { parse_params_from_url } from 'commons/utils';
// filters
import { questions_items, sort_by_items } from 'conf/filters';

export default function SubHeaderContainer(props)
{
    const default_current_tag = '';
    
    const default_order_by = questions_items.meta.default;
    const default_sort_by = sort_by_items.meta.default;
    
    const clean_up_taglist = (obj) =>
    {
        let tmp = obj.map(({ id, name }) => ({id:id, name:name}));
        tmp.unshift({
            id: 'ALL',
            name: 'ALL'
        });
        //console.table(obj);
        return tmp;
    };

    // delegates
    function delegate_for_btn_filter(evt)
    {
        if (are_flters_visible) { set_filter_visible(false) } else { set_filter_visible(true) };
    }

    const [are_flters_visible, set_filter_visible] = useState(false);
    const [tags_is_ready, set_tags_ready] = useState(false);
    const [tags_list, set_tags_list] = useState([]);

    const [current_tag, set_current_tag] = useState(default_current_tag);
    const [current_order_by, set_current_order_by] = useState(default_order_by);
    const [current_sort_by, set_current_sort_by] = useState(default_sort_by);

    const get_tag_name_from_id = (id) =>
    {
        if (tags_list.length < 1) return '';
        try
        {
            return tags_list.filter(item => item.id === id)[0].name;
        }
        catch (err)
        {
            return 'Recently asked questions';
        }
    }

    const get_tag_description_from_id = (id) =>
    {
        if(tags_list.length < 1) return '*** TAGS NOT CONFIGURED? ***';
        try
        {
            return tags_list.filter(item => item.id === id)[0].description;
        }
        catch (err)
        {
            return 'Take advantage of the Q&amp;A section to ask questions about needs that you have about CCH Tagetik usage and answer questions to share your knowledge and expertise.';
        }
    }
    // get taglist
    useEffect(() =>
    {
        let mounted = true;
        get_tags_from_server().then(obj =>
        {
            if (obj.status && obj.status === 'ok')
            {
                if (mounted)
                {
                    set_tags_ready(true);
                    set_tags_list(clean_up_taglist(obj.data));
                }
            }
        });
        return () => mounted = false; // cleanup function
    }, []);

    // read params from url
    const history = useLocation();

    // using to redirect from /base_dir/ to /base_dir/questions
    useEffect(() =>
    {
        const params = parse_params_from_url(window.location.href);
        //console.log("params are => " + JSON.stringify(params) );
        if(params.filters.tag !== '')set_current_tag(params.filters.tag); else set_current_tag('');
        if(params.filters.order_by !== '') set_current_order_by(params.filters.order_by); else set_current_order_by(default_order_by);
        if(params.filters.sort_by !== '') set_current_sort_by(params.filters.sort_by); else set_current_sort_by(default_sort_by);
    }, [history.search, default_order_by, default_sort_by]);


    if (!tags_is_ready)
    {
        return (
            <div className='sub-header-container'>
                waiting...
            </div>
        )
    }
    else
    {
        return (
            <>
                <div id="subheader">
                    <div id="subheader-header">
                        <h2>{get_tag_name_from_id(current_tag)}</h2>

                        <div><AskButton conf={conf} /></div>
                    </div>
                    <div id="subheader-body">
                        <div dangerouslySetInnerHTML={{ __html: get_tag_description_from_id(current_tag) }} />
                    </div>
                    <div id="subheader-footer">
                        <SubTitle total={props.numbers_of_results}
                                  current_tag={current_tag}
                                  current_order_by={current_order_by}
                                  current_sort_by={current_sort_by}
                                  tags={tags_list}
                                  questions_items={questions_items}
                                  sort_by_items={sort_by_items}
                        />
                        <div id="filters-button">
                        <button className='button button-small' onClick={delegate_for_btn_filter}><i className="ui-icon-list"></i> Filter Questions</button>
                        </div>
                    </div>
                    <FilterMenu
                                show={are_flters_visible}
                                tags={tags_list}
                                sort_by_items={sort_by_items}
                                questions_items={questions_items}
                                current_tag={current_tag}
                                current_order_by={current_order_by}
                                current_sort_by={current_sort_by}
                            />
                </div>
            </>
        );
    }
};
